import React from "react";
import classes from "../Styles/home.module.css";
import { useTypewriter } from "react-simple-typewriter";
import { Container, Grid, Typography, Box } from "@mui/material";
import boye from "../Assets/boye.jpeg";

const Home = () => {
  const { text } = useTypewriter({
    words: [
      "Web-Developer",
      "Frontend Dev",
      "Backend Dev",
      "Fullstack Dev",
      "Pythoneer",
      "AI/ML-Enthusiast ",
    ],
    loop: false,
    cursorStyle: "_",
    typeSpeed: 70,
    deleteSpeed: 50,
    delaySpeed: 1000,

    onLoopDone: () => console.log("done from typewriter hook"),
  });
  return (
    <>
      <Container
        disableGutters
        maxWidth="100vw"
        sx={{
          height: { xs: "85vh", md: "85vh" },
          pl: { xs: 3, md: 20 },
          pr: { xs: 3, md: 20 },
          pt: { xs: 10, md: 0 },
          pb: { xs: 18, sm: 30, md: 0 },
        }}
        className={classes.home_body}
      >
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          className={classes.grid_container}
        >
          <Grid item md={6} xs={12} sx={classes.grid_item}>
            <Typography className={classes.intro_text}>
              Hello World. I am
            </Typography>
            <Typography className={classes.intro_name}>
              Oyelola Adeboye
            </Typography>
            <Box sx={{ pb: 10 }}>
              <Box
                component="span"
                sx={{
                  color: { xs: "#43D9AD", md: "#4D5BCE" },
                  fontSize: { xs: "20px", md: "32px" },
                  fontFamily: " 'Fira Code', monospace !important",
                }}
              >
                {`>`}
              </Box>
              <Box
                component="span"
                sx={{
                  color: { xs: "#43D9AD", md: "#4D5BCE" },
                  fontSize: { xs: "20px", md: "32px" },
                  pl: 1,
                  fontFamily: " 'Fira Code', monospace !important",
                }}
              >
                {text}
              </Box>
            </Box>
            <Typography
              sx={{
                display: { xs: "none", md: "block" },
              }}
              className={classes.intro_comment}
            >
              {`//`}
            </Typography>
            <Typography
              sx={{
                display: { xs: "none", md: "block" },
              }}
              className={classes.intro_comment}
            >
              {`// you can also see it on my Github page`}
            </Typography>
            <Typography
              sx={{
                display: { xs: "block", md: "none" },
              }}
              className={classes.intro_comment}
            >
              {`// find my profile on Github:`}
            </Typography>
            <Typography className={classes.intro_github}>
              <span className={classes.intro_const}>const</span>
              <span className={classes.intro_git}>github</span> =
              <span>
                <a
                  className={classes.intro_gitlink}
                  href="https://github.com/Boye-dev"
                  target="blank"
                >
                  "https://github.com/Boye-dev"
                </a>
              </span>
            </Typography>
            {/* <Box
              sx={{
                position: "relative",
                display: { xs: "block", md: "none" },
              }}
            >
              <Box className={classes.blur_small}></Box>
              <Box className={classes.other_blur_small}></Box>
            </Box> */}
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            sx={{
              display: { xs: "none", md: "block" },
              p: 5,
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: "70%",
                height: "auto",
                borderRadius: "50%", // Make the Box rounded
                position: "absolute",
                top: "-200%",
                overflow: "hidden", // Ensure no part of the image exceeds the box
              }}
            >
              <img
                src={boye}
                width="100%"
                height="100%"
                alt="boye"
                style={{
                  objectFit: "cover", // Ensures image is not squashed
                  borderRadius: "50%", // Rounds the image itself
                }}
              />
            </Box>
            {/* <Box
              sx={{
                // marginBottom: { xs: 5, md: 0.3 },
                backgroundImage: `url(${boye})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
                width: "100%",
                height: "450px",
                borderRadius: "100%",
                position: "absolute",
                top: "-200%",
              }}
            /> */}
            <Box>
              <Box className={classes.blur}></Box>
              <Box className={classes.other_blur}></Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Home;
